import React from "react";
import "../Introduction/Introduction.css";
// import { IoIosArrowUp } from "react-icons/io";
import image from "../Assets/background_img.jpg";

function Introduction() {
  // const [isVisible, setIsVisible] = useState(false);

  // const goToBtn = () => {
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // };

  // const listenToScroll = () => {
  //   let heightToHidden = 250;
  //   const winScroll =
  //     document.body.scrollTop || document.documentElement.scrollTop;

  //   if (winScroll > heightToHidden) {
  //     setIsVisible(true);
  //   } else {
  //     setIsVisible(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", listenToScroll);
  //   return () => window.removeEventListener("scroll", listenToScroll);
  // }, []);
  return (
    <>
      <div className="gototop-main">
        <div className="introduction-img-div">
          <img src={image} alt="inhelers_img" className="introduction-img"/>
        </div>
      </div>
    </>
  );
}
export default Introduction;
